<template>
  <div>
    <a :href="downloadLinkHref" :download="filename" ref="fakeDownloadButton"></a>
    <base-button :type="type" :size="size" :loading="loading" @click="exportData()">
      <template #icon>
        <download-icon />
      </template>
      {{ label }}
    </base-button>
  </div>
</template>

<script>
import { DownloadIcon } from "@/assets/svgs";

export default {
  name: "ExportButton",
  components: { DownloadIcon },
  props: {
    label: { String },
    size: {
      type: String,
      default: "md",
      validator: (value) => ["xs", "sm", "md", "lg", "xl"].indexOf(value) !== -1,
    },
    filename: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: "primary",
    },
    requestPayload: Object,
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      downloadLinkHref: "",
      loading: false,
    };
  },
  methods: {
    exportData() {
      this.loading = true;

      this.$axios
        .post(this.url, this.requestPayload)
        .then((res) => new Blob([res.data]))
        .then((blob) => {
          this.downloadLinkHref = window.URL.createObjectURL(blob);
        })
        .then(() => {
          this.$refs.fakeDownloadButton.click();
        })
        .finally(() => {
          this.$emit("onFinish", "true");
          this.loading = false;
        })
        .catch((err) => {
          this.$emit("onError", err);
          this.loading = false;
        });
    },
  },
};
</script>
